import type { ReactNode } from 'react';
import { useWootric } from '@/hooks/useWootric';
import { useCookieConsent } from '@/providers/CookieConsentProvider';
import type { WootricDomain, WootricUser } from '@/types/wootric';

interface WootricProviderProps {
  children: ReactNode;
  user: WootricUser | null;
  enabled?: boolean;
  wootricDomainOverride?: WootricDomain;
}

export function WootricProvider({ children, user, enabled = true, wootricDomainOverride }: WootricProviderProps) {
  const { hasAnalyticsConsent, isResolved } = useCookieConsent();

  // Only enable Wootric when cookie consent has been resolved and analytics is consented
  const isEnabled = enabled && isResolved && hasAnalyticsConsent;

  useWootric({ user, enabled: isEnabled, wootricDomainOverride });

  return <>{children}</>;
}
